import React from 'react';
import styled from 'styled-components';

const AriaAnnouncement = styled.div`
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  white-space: nowrap;
`;

const AriaAnnouncements = ({ announcements }) => {
  return (
    <div data-testid="aria-announcements" tabIndex={-1}>
      {Object.keys(announcements).map(announcementKey => (
        <AriaAnnouncement
          data-testid={`aria-announcement-${announcementKey}`}
          aria-live="polite"
          aria-atomic="true"
          tabIndex={-1}
          key={announcementKey}
        >
          {announcements[announcementKey]}
        </AriaAnnouncement>
      ))}
    </div>
  );
};

export default AriaAnnouncements;
